import React, { Component } from "react";
// import styles from "./Jobs.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Loader from "../../Loader/Loader";
import axios from "axios";
import ConfirmModal from "./ConfirmModal";
import EditModal from "./EditModal";
import styles from "./DataBox.scss";
import classnames from "classnames";

export default class Jobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      job_data: undefined,
      datum: undefined,
      data_schema: undefined,
      showConfirmModal: false,
      showEditModal: false
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  getNewDataSchema = () => {
    var data = { ...this.state.job_data[0] };
    var data_schema = {};

    Object.entries(data).map(ent => {
      if (ent[0] === "skills" || ent[0] === "_id") {
        return null;
      } else {
        data_schema[ent[0]] = "";
        return null;
      }
    });
    this.showEditModal(data_schema);
  };
  showEditModal = datum => {
    this.setState({ showEditModal: true, datum: datum });
  };
  hideEditModal = () => {
    this.setState({ showEditModal: false });
  };

  updateTable = () => {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .get("/api/jobs/",
  		{
  			headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
  		})
      .then(res => {
        this.setState({
          job_data: res.data
        });
      })
      .catch(e => console.log(e));
  };

  showConfirmModal = datum => {
    this.setState({ showConfirmModal: true, datum: datum });
  };

  hideConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  deleteData(datum, type) {
    axios.defaults.headers.common["Authorization"] = localStorage.getItem(
      "jwt"
    );
    axios
      .post("/api/admin/removejobdata/", datum)
      .then(res => {
        this.updateTable();
      })
      .catch(e => console.log(e));
  }

  getDataSchema = data => {
    var data_schema = {};

    Object.entries(data).map(ent => {
      if (ent[0] === "skills" || ent[0] === "sector") {
        return null;
      } else {
        data_schema[ent[0]] = ent[1];
        return null;
      }
    });
    this.showEditModal(data_schema);
  };
  render() {
    if (!this.state.job_data) {
      return <Loader />;
    } else {
      return (
        <div className={styles.dataBox}>
          <ConfirmModal
            show={this.state.showConfirmModal}
            handleClose={this.hideConfirmModal}
            data={this.state.datum}
            deleteData={this.deleteData}
            updateTable={this.updateTable}
            type={this.state.type}
          />
          <EditModal
            show={this.state.showEditModal}
            handleClose={this.hideEditModal}
            data={this.state.datum}
            updateOrAdd={this.updateOrAdd}
            updateTable={this.updateTable}
            type={"Job Data"}
          />
          <div className={classnames("table-responsive", styles.table)}>
            <table className="table table-striped w-auto">
              <thead>
                <tr>
                  <td>Title</td>
                  <td>Company</td>
                  <td>Sectors</td>
                  <td>URL</td>
                  <td>Image URL</td>
                  <td>Description</td>
                  <td>Type</td>
                  <td>Predictions</td>
                  <td>Predicted</td>
                  <td>Contract</td>
                  <td>Bilingual</td>
                  <td>Education</td>
                  <td>Experience</td>
                  <td>Clean Title Description</td>
                  {/* <th scope="col">Edit</th> */}
                  <th scope="col">Delete</th>
                </tr>
              </thead>
              <tbody>
                {this.state.job_data.map((row, i) => (
                  <tr key={i}>
                    <td>{row.title}</td>
                    <td>{row.company}</td>
                    <td>{row.sectors.join(", ")}</td>
                    <td><a href={row.url}>{row.url}</a></td>
                    <td><a href={row.img}>{row.img}</a></td>
                    <td>{row.description}</td>
                    <td>{row.type}</td>
                    <td>{row.predictions.join(", ")}</td>
                    <td>{row.predicted}</td>
                    <td>{row.contract}</td>
                    <td>{row.bilingual}</td>
                    <td>{row.education}</td>
                    <td>{row.experience}</td>
                    <td>{row.clean_title_desc}</td>

                    <td className="textCenter">
                      <FontAwesomeIcon
                        className={styles.cursor}
                        onClick={() => this.showConfirmModal(row)}
                        style={{ color: "#323643" }}
                        icon={faTrash}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Admin/Jobs.js